
<template>
    <div class="plan-page">
        <div class="add-user-form-profile parent-add-detail">
            <div class="medium-font-500">Hello, {{user.name}}</div></br>
                <div v-if="user && user.parent">
                <div class="target-main medium-font-500">
                    <div class="medium-font-500">The details of the Parent ID associated with you is:</div>
                </div>
                <div class="target-main medium-font-500">Parent Name: <span>{{user.parent.name}}</span></div>
                <div class="target-main medium-font-500">Parent Email: <span>{{user.parent.email}}</span></div>
                <div>
                <v-col cols="12" sm="4" class="rg-center b-data">
                    <v-btn @click="onAdd()" class="right-btn cust-btn" color="primary">Edit Parent</v-btn>
                </v-col>
                </div>
            </div>
            <div v-else>
                <div>
                    <div class="medium-font-500">Presently, you do not have any parent email ID associated to your account.</div>
                </div>
                <v-col cols="12" sm="4" class="rg-center b-data">
                    <v-btn :loading="loading" @click="onAdd()" class="right-btn cust-btn" color="primary">Add Parent</v-btn>
                </v-col>
            </div>  
            <div>             
                <div v-if="addParentForm">
                    <v-col cols="4" sm="4" class="">
                        <div class="parent-name">
                            <v-text-field  
                                v-model="parentName"
                                label="Parent Name"
                                outlined
                                dense
                                hide-details="auto"
                                required
                            >
                            </v-text-field>
                            <InputError :data="error.name" />
                        </div>
                        <div class="parent-name">
                            <v-text-field
                                v-model="parentEmail"
                                label="Parent Email ID"
                                outlined
                                dense
                                hide-details="auto"
                                required
                            ></v-text-field>
                            <InputError :data="error.email" />
                        </div>
                    </v-col>
                    <div>
                        <v-col cols="12" sm="4" class="rg-center b-data verify-btn">
                            <v-btn v-if="user.parent && parentEmail===user.parent.email" @click="updateParentName()" class="right-btn cust-btn verification-btn" color="primary">Submit</v-btn>
                            <v-btn v-else @click="sendCode()" :loading="loading" class="right-btn cust-btn verification-btn" color="primary">Send Verification Code</v-btn>
                        </v-col>
                    </div>
                </div>
            </div>
        </div>
    <AlertBox
      :width="modalwidth"
      :onClose="onClose"
      :component="cComponent"
      :status="status"
      :data="alertData"
      :contentClass="contentClass"
    />
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import constants from "@/utils/constants.js";
export default {
    name: "PersonalProfile",
    props: ["tab"],
    mounted() {
        this.onlineInstitute = (this.user.institute !== constants.ONLINE_INSTITUTE_ID) ? true : false;
        this.parentDetails = this.user && this.user.parent ? this.user.parent : '';
        if(this.parentDetails!==null){   
            this.parentName=this.parentDetails.name;
            this.parentEmail=this.parentDetails.email;
            this.parentId=this.parentDetails.id;           
        }       
    },
    data() {
        return {
            parentDetails:{},
            phone: {},
            status: false,
            error: {
                name:{
                    type: null,
                    message: null
                },
                email: {
                    type: null,
                    message: null
                },
            },
            onlineInstitute: false, 
            addParentForm: false,
            parentName: "",
            parentEmail: "",
            cComponent: "",
            alertData: null,
            data:null,
            modalwidth: null,
            userId: null,
            parentId:"",
            contentClass:'',
            loading:false
        };
    },

    methods: {
        ...mapActions({
            updateProfile: "userStore/updateProfile",
            me: "userStore/me",
            signUp: "userStore/signUp",
            updateUser: "userStore/updateUser"
        }),
        onDone(type) {
            if (this.validate()) {
                let formdata = new FormData();
                if (type == "form") {
                    formdata.append("reqData[email]", this.user.email);
                    formdata.append("reqData[parent_email]",this.parentEmail);
                    formdata.append("reqData[parent_name]",this.parentName);
                }
                this.updateProfile(formdata)
                    .then(response => {
                        this.blob = null;
                        this.$toasted.success(`Profile updated successfully`, {
                            icon: "check_circle"
                        });
                    })
                    .catch(err => {});
            }
        },
        onClose(data) {
            this.status = data.status;
            this.otpErrMessage=null;
        },
        validate() {
            this.parentEmail = this.removeWhiteSpacesFromEmail(this.parentEmail);
            let isValid = true;
            this.error.name.type = null;
            this.error.email.type = null;
            if (!this.parentName || this.parentName.trim().length < 1) {
                this.error.name.type = "error";
                this.error.name.message = "Please enter valid name";
                isValid = false;
            }
            if (!this.parentEmail || this.parentEmail.trim().length < 1) {
                this.error.email.type = "error";
                this.error.email.message = "Please enter email ID";
                isValid = false;
            } else if (!this.isValidEmail(this.parentEmail)) {
                this.error.email.type = "error";
                this.error.email.message =
                    "The email ID entered by you is invalid. Please enter a valid email ID.";
                isValid = false;
            }
            return isValid;
        },
        onAdd(){
            this.loading=true;
            this.addParentForm = !this.addParentForm;          
            let user=this.user;
            this.parentEmail=user&& user.parent && user.parent.email ?user.parent.email : '';        
            this.parentName=user&& user.parent && user.parent.name ? user.parent.name : '';      
            this.loading = false;     
        },
        updateParentName(){                           
           if (this.validate()) {
                let formdata = new FormData();
                let user=this.user;
                    formdata.append("reqData[parent_name]",this.parentName);
                    formdata.append("reqData[parent_id]",user.parent.id);

                this.updateProfile(formdata)
                    .then(response => {
                        user.parent.name=this.parentName;
                        this.updateUser(user);
                        this.$toasted.success(`Parent details updated successfully`, {
                            icon: "check_circle"
                        });
                    })
                    .catch(err => {});
            }
        },
        sendCode(){
            if(this.validate()){
                this.loading=true;
                this.signUp({
                name: this.parentName,
                email: this.parentEmail,
                role_id: this.roleIds.PA,
                // confirmation_otp_required : true,
                selectedRoleForPreSelect: {
                    id: this.roleIds.PA,
                    role_name: "Parents",
                    created_at: null,
                    updated_at: null,
                    created_by: null,
                    role_type: "e",
                    role_code: this.roles.PA_ROLE_CODE
                },
                details: {
                    name: this.user.name,
                    email: this.user.email
                },
                internal: false,
                parent_registration_otp: true
            })
                .then((response) => {
                    this.loading = false;
                    this.status = true;
                    this.cComponent = "components/profile/VerificationModal";
                    this.alertData = {
                        parentEmail: this.parentEmail,
                        parentName: this.parentName,
                        userEmail: this.user.email,
                        userId: response.user_id,
                    };    
                    this.status =true
                    this.contentClass = 'otp-modal-box verify-modal-box'
                    this.modalwidth = "390px";
                    this.$forceUpdate()
                    this.addParentForm = false;    
                })
                .catch((err) => {
                    this.loading = false;
                });
                ;
            }
            
        },
    },
    computed: {
        ...mapState("userStore", ["user"]),
        getCountryCodes() {
            if (this.countryList && this.countryList.length) {
                return this.countryList.map(c => {
                    return "+" + c.dialingcode;
                });
            }
        },
        userSelectedFile() {
            return this.slectedFile;
        }
    },
};
</script>